import React, {useContext, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {AuthContext} from '../auth/ContextAuthentication';
import useAxiosConfig from '../config/AxiosConfig';

const UpdatePassword = () => {
  const axiosInstance = useAxiosConfig();
  const navigate = useNavigate();
  const {clearSession} = useContext(AuthContext);
  const [currentPassword, setCurrentPassword] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setMessage('');
    setError('');

    if (!currentPassword || !password || !confirmPassword) {
      setError('Please fill in all password fields.');
      return;
    }
    if (password.length < 12) {
      setError('The new password must be at least 12 characters.');
      return;
    }
    if (password !== confirmPassword) {
      setError('Confirm password does not match.');
      return;
    }
    if (password === currentPassword) {
      setError('The new password must be different from the current password.');
      return;
    }

    setSaving(true);
    try {
      const response = await axiosInstance.post('/api/admin/updatepassword', {
        currentPassword,
        password,
      });

      if (response?.data?.status !== true) {
        setError(response?.data?.message || 'Unable to update the password.');
        return;
      }

      setCurrentPassword('');
      setPassword('');
      setConfirmPassword('');
      setMessage('Password updated. Existing sessions were revoked. Sign in again with the new password.');

      window.setTimeout(() => {
        clearSession();
        navigate('/login');
      }, 1200);
    } catch (requestError) {
      setError(requestError?.response?.data?.message || 'Unable to update the password.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="flex min-h-[70vh] items-center justify-center p-6">
      <div className="w-full max-w-md rounded-lg bg-white p-6 shadow">
        <h1 className="text-2xl font-semibold text-gray-900">Change administrator password</h1>
        <p className="mt-2 text-sm text-gray-600">
          Confirm your current password. A successful change revokes all existing administrator sessions.
        </p>

        <form className="mt-6 space-y-4" onSubmit={handleSubmit}>
          <label className="block">
            <span className="text-sm font-medium text-gray-700">Current password</span>
            <input
              type="password"
              autoComplete="current-password"
              value={currentPassword}
              onChange={(event) => setCurrentPassword(event.target.value)}
              className="mt-1 w-full rounded border px-3 py-2"
              required
            />
          </label>

          <label className="block">
            <span className="text-sm font-medium text-gray-700">New password</span>
            <input
              type="password"
              autoComplete="new-password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              className="mt-1 w-full rounded border px-3 py-2"
              minLength={12}
              required
            />
          </label>

          <label className="block">
            <span className="text-sm font-medium text-gray-700">Confirm new password</span>
            <input
              type="password"
              autoComplete="new-password"
              value={confirmPassword}
              onChange={(event) => setConfirmPassword(event.target.value)}
              className="mt-1 w-full rounded border px-3 py-2"
              minLength={12}
              required
            />
          </label>

          {error && <p role="alert" className="text-sm font-medium text-red-700">{error}</p>}
          {message && <p role="status" className="text-sm font-medium text-green-700">{message}</p>}

          <button
            type="submit"
            disabled={saving}
            className="w-full rounded bg-[#0C7240] px-4 py-2 font-medium text-white disabled:opacity-50">
            {saving ? 'Updating…' : 'Update password'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default UpdatePassword;
